export default __webpack_public_path__ + "static/media/1802099_Rishu_EE.17fbbc79.pdf";